import DrawerBar from '@/common/components/NavigationBar/DrawerBar';

export default DrawerBar;
